/**
 * 공통 사용될 코드
 */
export const ECode = {
    Success: "000",
    ExpiredToken: "001",
};
//# sourceMappingURL=ECode.js.map